export const GET_ECGS_LIST_DATA = 'GET_ECGS_LIST_DATA'
export const GET_ECGS_DATA = 'GET_ECGS_DATA'
export const GET_ECGS_DOCUMENT = 'GET_ECGS_DOCUMENT'
export const ECGS_DOC_LOADING = 'ECGS_DOC_LOADING'
export const SET_ECG_LOADING = 'SET_ECG_LOADING'
export const RESET_ECG_MODAL = 'RESET_ECG_MODAL'
export const CLEAR_ECGS = 'CLEAR_ECGS'
